import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"-webkit-center"} }


import {reactive, ref} from "vue";
import {router} from "@/router";
import {useStore} from "vuex";
import VerificationCode from "./verificationCode.vue";
import request from "@/api";
import {ElMessage} from "element-plus";

// const props = defineProps({
//   isShow1: Boolean,
//   isShow2: Boolean,
// });


export default /*#__PURE__*/_defineComponent({
  __name: 'loginIn',
  setup(__props, { emit: emits }) {




function updateParentShow(show1: boolean, show2: boolean) {
  emits("updateShow", show1, show2);
}

const verificationCode = ref();
const store = useStore();
let user = reactive({
  code: "",
  username: "",
  password: "",
});

function loginIn() {
  // router.push('/datasetPreview')
  if (verificationCode.value.verificateFlag() === true) {
    let temp = {
      code: verificationCode.value.verCode,
      username: user.username,
      password: user.password,
    };
    console.log(temp);
    // console.log("登录访问验证码session" + JSON.parse(sessionStorage.getItem("captcha")));
    request
        .post("/user/login", temp)
        .then((res) => {
          console.log(res)
          if (res.data.msg === "登陆成功") {
            console.log("登陆成功")
            const userInfo = res.data.data.userInfo
            const userTicket = res.data.data.token
            let access = userInfo.authority
            store.commit("loginIn");
            store.commit("setUserTicket", userTicket);
            console.log("store.state.userTicket: ", store.state.userTicket)
            store.commit("setAccount", user.username)
            store.commit('setAccess', access)
            store.commit('setPhone', userInfo.telephone)
            store.commit('setInstitute', userInfo.institute)
            console.log("userInfo.institute: ", userInfo.institute)
            console.log("store.state.institute: ", store.state.institute)
            // if (store.state.isAut === true) {
            //   alert("登录成功！");
            router.push('homepage')
            // }
          } else if (res.data.msg==="用户不存在"){
            ElMessage.error("User does not exist.")
            // alert("User does not exist.")
            verificationCode.value.getCode()
            console.log(res);
          }else if(res.data.msg==="用户名或密码错误"){
            ElMessage.error("Username/Password is incorrect.")
            // alert("用户名或密码错误!")
            verificationCode.value.getCode()
          }
        })
        .catch((err) => {
          console.log((err));
        });
  } else {
    ElMessage.error("Verification code is wrong!")
    // alert("验证码错误");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _unref(user),
      "label-width": "120px",
      style: {"width":"max-content"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "Account:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(user).username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(user).username) = $event)),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Password:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(user).password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(user).password) = $event)),
              type: "password",
              "show-password": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Verification:" }, {
          default: _withCtx(() => [
            _createVNode(VerificationCode, {
              ref_key: "verificationCode",
              ref: verificationCode
            }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { style: {"margin-left":"120px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: loginIn
            }, {
              default: _withCtx(() => [
                _createTextVNode("Log in")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})